<template>
  <!-- ==================== SuriSuri 운영 어시스턴트 (플로팅 위젯 컨테이너) ====================
    회귀 금지 #3 준수: cs-front 디자인 토큰(--color-primary 계열) inherit.
    FAB + Panel 조립 + 전역 키보드(Ctrl+K 토글 / Esc 닫기)만 담당.
    스트리밍/JWT/HITL 로직 → useAssistant composable, 상태 → Pinia stores/assistant. -->
  <div class="assistant-widget">
    <assistant-floating-button />
    <assistant-panel />
  </div>
</template>

<script>
import { useAssistantStore } from '@/stores/assistant'
import { useAssistant } from '@/composables/useAssistant'
import AssistantFloatingButton from './AssistantFloatingButton.vue'
import AssistantPanel from './AssistantPanel.vue'

/**
 * @component AssistantWidget
 * @description 전역 운영 어시스턴트 컨테이너. FAB와 Panel을 조립하고,
 * 항상 마운트되는 위치에서 전역 키보드 단축키를 단일 리스너로 처리한다
 * (Ctrl/Cmd+K 토글, Esc 닫기). 누수 방지를 위해 beforeUnmount에서 해제한다.
 */
export default {
  name: 'AssistantWidget',
  components: { AssistantFloatingButton, AssistantPanel },
  setup() {
    const store = useAssistantStore()
    // 새로고침 대화 복원(AA-143) — 이미 대화가 있으면(재마운트) 무시된다. 패널은 닫힌 채로 시작한다.
    useAssistant().restoreConversation()
    return { store }
  },
  mounted() {
    window.addEventListener('keydown', this.onGlobalKeydown)
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.onGlobalKeydown)
  },
  methods: {
    /**
     * 전역 키보드 단축키 핸들러.
     * @param {KeyboardEvent} e
     */
    onGlobalKeydown(e) {
      // Ctrl/Cmd+K → 패널 토글
      if ((e.ctrlKey || e.metaKey) && (e.key === 'k' || e.key === 'K')) {
        e.preventDefault()
        this.store.toggle()
        return
      }
      // Esc → 열려 있으면 닫기
      if (e.key === 'Escape' && this.store.open) {
        this.store.open = false
      }
    }
  }
}
</script>

<style scoped>
.assistant-widget {
  /* 자식(FAB/Panel)이 각각 position: fixed 이므로 컨테이너는 레이아웃에 영향 없음 */
  display: contents;
}
</style>
